import styled from 'styled-components'
import { useToasts } from 'react-toast-notifications'
import moment from 'moment'

import EmptyDetails from '../../../../components/EmptyDetails'
import Flex from '../../../../components/layouts/Flex'

import { P } from '../../../../style/Typography.style'

import useFetch from '../../../../hooks/useFetch'

const JobActivities = ({ jobId }) => {
  const { data, error } = useFetch('/job-activities?job_id=' + jobId)
  const { addToast } = useToasts()

  let component

  if (data?.resp && data.resp.length > 0) {
    component = data?.resp?.map((activity) => (
      <StyledJobActivities key={activity.id}>
        <Flex
          justifyContent="space-between"
          alignItems="center"
          direction="column"
          padding="0.5rem 0"
        >
          <P size="0.75rem" marginBottom="0.35rem">
            {activity.activities}
          </P>
          <P size="0.625rem" color="#676E92">
            {moment(activity.created_at).format('MMMM Do, YYYY | h:mm A')}{' '}
            {' GMT '}
            {moment(activity.created_at).format('ZZ')}
          </P>
        </Flex>
      </StyledJobActivities>
    ))
  } else {
    component = <EmptyDetails message="No job activities available." />
  }

  if (error) {
    addToast('Failed to fetch job activities.', { appearance: 'error' })
  }

  return <div>{component}</div>
}

const StyledJobActivities = styled.div`
  &::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 0;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    border: 1px solid #c4d0e9;
    background: #fff;
  }

  &::before {
    content: '';
    position: absolute;
    top: 4px;
    left: 4px;
    height: calc(100% - 4px);
    width: 1px;
    background: #c4d0e9;
    display: ${({ last }) => (last ? 'none' : 'block')};
  }
`

export default JobActivities
